import * as React from 'react';
import { LoadOptions } from 'app/types-shared';
import { CodeSinglePicker } from 'app/area/codetable/common';
import { ScreenPickerProps, ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';
import { codetableOptionsIds } from 'app/area/codetable/item/screen-renderer/screen-pickers/constants';
import { ReadOnlyType } from 'app/area/codetable/item/types';
import { getDisabledValidation } from 'app/area/shared/codetable/item/codetable-item-helpers';
import { manageOptionsButton } from 'app/area/shared/manage-options';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const DefaultUoMType = (props: ScreenPickerProps) => {

  const { breadcrumbs, codeItem, updateByKey, resetValidation, clearByKey, codetableOptions, loadCodetableOptions,
    translation, validation, readOnlyConfig } = props;

  const codetableId = codetableOptionsIds.defaultUomType;

  const onChange = (value: CodeComplexValue<number>) => {
    resetValidation(ScreenPicker.defaultUomType);
    updateByKey(ScreenPicker.defaultUomType, value);
    clearByKey(ScreenPicker.defaultUom);
    resetValidation(ScreenPicker.defaultUom);
  };

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    loadCodetableOptions(id, codetableId, {
      ...loadOptionsParams, displayNotSelected: false
    });
  };

  const codeOptions = (!!codetableOptions[ScreenPicker.defaultUomType]
    && codetableOptions[ScreenPicker.defaultUomType].codes || []) as CodeComplexValue<number>[];
  const uomValidation = !!validation && !!validation[ScreenPicker.defaultUomType] ? validation[ScreenPicker.defaultUomType] : undefined;
  const finalValidation = {
    ...uomValidation,
    ...getDisabledValidation(codeItem.defaultUomType?.disabled, translation.selected_value_disabled)
  };
  const readOnly = readOnlyConfig && readOnlyConfig[ReadOnlyType.all];

  const extraFooterButton = manageOptionsButton(translation.manage_options, codetableId, breadcrumbs);

  return <CodeSinglePicker
    id={ScreenPicker.defaultUomType}
    label={translation.default_uom_type}
    valueItem={codeItem && codeItem.defaultUomType}
    searchRequired={false}
    required={!readOnly}
    readOnly={readOnly}
    options={codeOptions}
    fetchingOptions={codetableOptions[ScreenPicker.defaultUomType] && codetableOptions[ScreenPicker.defaultUomType].fetching}
    translation={translation}
    onLoadOptions={onLoadOptions}
    onChange={onChange}
    extraFooterButton={extraFooterButton}
    validation={finalValidation}
  />;
};
